// extracted by mini-css-extract-plugin
module.exports = {"puntsClau":"puntsClau_puntsClau__sEPs8"};